import Player from '@vimeo/player';

const videoPlayer = {
    init() {

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        const videoWrapper = $('.vimeo-video');
        const playButton   =  $('.js-video-play')

        videoWrapper.each(function(index, el){
            var videoID = $(this).data('id');
        });

        playButton.on('click tap', function(e){
            $(this).parent().parent().animate({"opacity": 0}).addClass('pointer-none');
            var videoID = $(this).data('video');
            console.log('tap clicked');
            var videoName = 'video-' + videoID;
            var videoType = $(this).data('type');

            if(videoType == 'vimeo'){
                const player = new Player(videoName, {
                    id: videoID,
                });
                player.play();
            }else{


                // 2. This code loads the IFrame Player API code asynchronously.



                // 3. This function creates an <iframe> (and YouTube player)
                //    after the API code downloads.
                var player;
                onYouTubeIframeAPIReady()
                function onYouTubeIframeAPIReady() {
                    player = new YT.Player(videoName, {
                        height: '390',
                        width: '640',
                        videoId: videoID,
                        playerVars: {
                            'playsinline': 1
                        },
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });


                    // 4. The API will call this function when the video player is ready.
                    function onPlayerReady(event) {
                        event.target.playVideo();
                    }

                    // 5. The API calls this function when the player's state changes.
                    //    The function indicates that when playing a video (state=1),
                    //    the player should play for six seconds and then stop.
                    var done = false;
                    function onPlayerStateChange(event) {
                        if (event.data == YT.PlayerState.PLAYING && !done) {
                            setTimeout(stopVideo, 6000);
                            done = true;
                        }
                    }
                    function stopVideo() {
                        player.stopVideo();
                    }


                }


            }



        })


        //Always set id or url properties first


        var $bg = $('.video-con-url').attr('data-src');

        var element = document.getElementById('videoBackground');
        console.log(element);

        if($('.video-con')[0]){
            const player2 = new Player(element, {
                url: $bg,
                background: 1
            });

            player2.setVolume(0);
            player2.play();


        }






    }

}

export {videoPlayer}